const isFlagOn = (value) => value === 1 || value === true;

const getTargetId = (target) => {
  if (target === null || target === undefined) return null;
  if (typeof target === 'string' || typeof target === 'number') {
    return String(target) || null;
  }
  const rawId = target.uid ?? target.id ?? target.userId;
  if (rawId === null || rawId === undefined) return null;
  return String(rawId) || null;
};

const isSameUser = (a, b) => {
  const idA = getTargetId(a);
  const idB = getTargetId(b);
  return Boolean(idA && idB && idA === idB);
};

const isGroupOwner = (group, target) =>
  Boolean(group?.createdUserId && isSameUser(target, group.createdUserId));

const isAdminMember = (member) => Boolean(member && isFlagOn(member.isAdmin));

export const getViewerMember = (members, me) => {
  if (!Array.isArray(members) || members.length === 0) return null;
  return members.find((member) => isSameUser(member, me)) || null;
};

export const canManageMembers = (group, viewerMember, me) => {
  if (!group) return false;
  return isGroupOwner(group, me) || isAdminMember(viewerMember);
};
